import { SxProps } from '@mui/material';
import { Typography } from 'shared/mui/Typography';

import { BoxStyled } from './DashboardAmountCard.styled';

type Props = {
  title: string;
  text: string;
  color?: string;
  sx?: SxProps;
};

export const DashboardAmountCard: React.FC<Props> = ({ title, text, color, sx }) => {
  return (
    <BoxStyled sx={sx}>
      <Typography variant="body2">{title}</Typography>
      <Typography color={color} fontWeight={500} variant="body1">
        {text}
      </Typography>
    </BoxStyled>
  );
};
